import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  gap: 2rem;
  margin-top: 4rem;
  padding-bottom: 1rem;
`;

export const Orders = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
`;

export const UserInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
`;

export const BoxTitle = styled.h3`
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
`;

export const OrdersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;
`;

export const Order = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  background-color: #fff;
  border-radius: 12px;
  padding: 0.8rem 1rem;

  h4 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 500;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;

    span {
      margin: 0;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }
`;

export const Counter = styled.div`
  max-width: 18px;
  max-height: 18px;
  min-width: 18px;
  min-height: 18px;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.7rem;
  background-color: var(--primary-green);
  color: #fff;
  font-weight: 400;
  padding-top: 0.4rem;
`;

export const OptionsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Options = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 2rem;

  p {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 300;
  }
`;

export const OptionsGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;

  > div:not(:last-child) {
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
  }

  > div {
    width: 100%;
    padding-left: 0.3rem;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InfosContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  background-color: #fff;
  border-radius: 12px;
  padding: 0.8rem 1rem;

  p {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: justify;
    margin-top: 2px;
  }
`;

export const Infos = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const InfosBox_1 = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
`;

export const InfosBox_2 = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
`;

export const Description = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`;

export const TeaBoyInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
`;

export const TeaBoyBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #fff;
  border-radius: 12px;
  padding: 0.8rem 1rem;

  p {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: justify;
    margin-top: 2px;
  }
`;

export const InfosBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2rem;
`;

export const DeliveredStatus = styled.h4`
  padding: 8px 12px;
  border-radius: 8px;
  color: #1dbaaf;
  border: 1px solid #1dbaaf;
  background-color: #d2f1ef;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`;

export const PendingStatus = styled.h4`
  padding: 8px 12px;
  border-radius: 8px;
  color: #ff9c72;
  border: 1px solid #ff9c72;
  background-color: #ffebe3;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`;

export const CancelledStatus = styled.div`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ff6464;
  background-color: #ffe0e0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CancelledStatusTitle = styled.h4`
  color: #ff6464;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`;

export const TooltipContainer = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  transition: 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);

  span {
    position: relative;
    z-index: 2;
  }

  &:hover .TooltipBox {
    // bottom: calc(100% + -86px);
    // right: -12px;
    opacity: 1;
    pointer-event: auto;
    width: max-content !important;
    max-width: 40vw;
  }
`;

export const TooltipBox = styled.div`
  width: max-content !important;
  max-width: 40vw;
  min-width: 30vw;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;
  position: absolute;
  // bottom: calc(100% + -160px);
  margin-top: 8px;
  right: 0;
  margin-right: -12px;
  z-index: 1;
  background-color: #fff;
  color: #000;
  border-radius: 8px;
  opacity: 0;
  pointer-event: none;
  box-shadow: 0px 16px 24px 0px #00000033;
  transition: 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  padding: 16px;

  &:before {
    position: absolute;
    content: '';
    height: 10px;
    width: 10px;
    background: inherit;
    left: 97%;
    top: -5px;
    transform: translateX(-79%) rotate(45deg);
  }

  h5 {
    color: #ff6464;
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }

  p {
    color: #1d252d;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: justify;
  }
`;

export const FoodTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FoodImage = styled.div`
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  // object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
`;
